import React from "react";
import { AddRackOptions } from "../../constants";
import { DateSelector } from "../selectors/DateSelector";
import { RunSelector } from "../selectors/RunSelector";

interface QCProps {
  values: AddRackOptions;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void;
}

export const QC = ({ values, setFieldValue }: QCProps) => {
  return (
    <React.Fragment>
      <RunSelector values={values} setFieldValue={setFieldValue} />
      <DateSelector values={values} setFieldValue={setFieldValue} />
    </React.Fragment>
  );
};
